import { setSuggestionSegmentsInternal } from '../actions/internalActions';
import getSegmentSearchBoxText from '../utils/getSegmentSearchBoxText';
import { SubstrateSearchSuggestionSegment } from 'owa-search-service';
import { orchestrator } from 'satcheljs';
import {
    onSearchTextChanged,
    setSuggestionSegments,
    clearSearchBox,
} from '../actions/publicActions';

export default orchestrator(setSuggestionSegments, actionMessage => {
    const scenarioId = actionMessage.scenarioId;
    const segments: SubstrateSearchSuggestionSegment[] = actionMessage.segments;
    const lastSegment = segments.slice(-1)[0];

    // Clear search box when segments are added.
    clearSearchBox(scenarioId);

    // Update store with segment data.
    setSuggestionSegmentsInternal(segments, scenarioId);

    // Update search text if suggestion was actually selected.
    if (actionMessage.suggestionSelected) {
        onSearchTextChanged(getSegmentSearchBoxText(lastSegment), scenarioId);
    }
});
